import { Component, effect, Input, signal } from '@angular/core';
// import { CategoriesService } from 'src/app/services/app/categories.service';
import { AssemblyFilterService } from '../assembly-filter.service';
// import { OfficesService } from 'src/app/services/global/offices.service';
import { Category } from 'src/app/models/category.model';
import { MenuItem } from 'primeng/api';
import { Franchise } from 'src/app/models/franchise.model';
import { Assembly } from 'src/app/models/assembly.model';
// import { SelectedAssemblyService } from 'src/app/services/app/selected-assembly.service';
import { BannerMessagesService } from 'src/app/services/app/banner-messages.service';
import { ToolbarModule } from 'primeng/toolbar';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CategoriesService } from '@/services/api/categories.service';
import { OfficesService } from '@/services/api/franchises.service';
import { AssembliesService } from '@/services/api/assemblies.service';
import { MenubarModule } from 'primeng/menubar';

interface CategoryMenuItem extends Category {
  icon: string;
}

@Component({
    selector: 'app-assembly-filter',
    imports: [
        ToolbarModule,
        SelectModule,
        SelectButtonModule,
        ButtonModule,
        FormsModule,
        CommonModule,
        MenubarModule
    ],
    template: `
    <p-menubar>
    <ng-template #start>
      
    <div class="flex flex-col gap-4">
                    <div class="flex flex-wrap gap-4">
                        <div class="flex flex-col grow basis-0 gap-2">
                        <label for="office">Office</label>
                            <p-select [options]="filteredOffices" 
                appendTo="body"
                id="office"
                [ngModel]="officesService.selectedOffice()" optionLabel="CityCode"
                    [style]="{'width':'100%'}" (onChange)="onSelectOffice($event.value)"
                    placeholder="Select an office" />
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                        <label for="category">Category</label>
                            <p-select [options]="categoriesService.categories()" 
                    [filter]="true"
                    id="category"
                    filterBy="Name" 
                    appendTo="body"
                    [(ngModel)]="selectedCategory"
                    optionLabel="Name" 
                    optionValue="CategoryID" 
                    placeholder="Select a category">
                    </p-select>
                        </div>
                    </div>
                </div>
   
    </ng-template>

    <ng-template #end>
        <div class="flex items-center gap-2">
        <p-selectButton [options]="assemblyTypes" optionLabel="label" optionValue="value" [(ngModel)]="selectedType" (onChange)="toggleAssemblies($event.value)"></p-selectButton>
        <button pButton type="button" label="Add Assembly" (click)="addAssembly()"></button>
        </div>
    </ng-template>
</p-menubar>
    <!-- <p-toolbar>
    <div class="p-toolbar-group-start">
        <div class="flex align-items-center py-1 px-1 surface-border flex-wrap">
            <div class="text-500 w-3 md:w-1 font-medium mr-5 text-right">Category</div>
            <div class="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
            <p-select [options]="categoriesService.categories()" 
                    [filter]="true"
                    filterBy="Name" 
                    appendTo="body"
                    [(ngModel)]="selectedCategory"
                    optionLabel="Name" 
                    optionValue="CategoryID" 
                    placeholder="Select a category">
                    </p-select>
            </div>
        </div>
        <div class="flex align-items-center py-1 px-1 surface-border flex-wrap" *ngIf="!officeLocked">
            <div class="text-500 w-3 md:w-1 font-medium mr-5 text-right">Office</div>
            <div class="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
                <p-select [options]="filteredOffices()" 
                appendTo="body"
                [ngModel]="officesService.selectedOffice()" optionLabel="CityCode"
                    [style]="{'width':'100%'}" (onChange)="onSelectOffice($event.value)"
                    placeholder="Select an office" />
            </div>
        </div>
    </div>
    <div class="p-toolbar-group-center">
        <div class="flex align-items-center py-1 px-1 surface-border flex-wrap">
            <div class="text-500 w-3 md:w-1 font-medium mr-5 text-right">Type</div>
            <div class="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
                <p-selectButton [options]="assemblyTypes" optionLabel="label" optionValue="value" [(ngModel)]="selectedType" (onChange)="toggleAssemblies($event.value)"></p-selectButton>
            </div>
        </div>
    </div>
    <div class="p-toolbar-group-end" *ngIf="!outputMode">
        <button pButton type="button" label="Add Assembly" (click)="addAssembly()"></button>
    </div>
    </p-toolbar> -->
    `,
    styles: `
    .ui-menu {
    overflow-y: scroll;      
    height: 200px;      
  }
    `
})
export class AssemblyFilterComponent {
  assemblyTypes: any[] = [
    { label: 'All', value: '' },
    { label: 'Options', value: 'O' },
    { label: 'Standards', value: 'S' }
  ];
  selectedType: string = '';
  sortOrder!: number;
  sortField!: string;
  categoriesMenu: CategoryMenuItem[] = [];

  @Input() officeLocked:boolean = false;
  @Input() outputMode:boolean = false;

  constructor(
    public categoriesService: CategoriesService,
    public assemblyFilterService: AssemblyFilterService,
    public officesService: OfficesService,
    public selectedAssemblyService: AssembliesService,
    public bannerMessagesService: BannerMessagesService
  ) {
    if(this.officesService.offices().length === 0) {
      this.officesService.fetchOffices();
    }
  }

  get filteredOffices() {
    return this.officesService.getFilteredOffices('Assemblies', 'edit');
  }

  set selectedCategory(categoryId: number) {
    console.log('setting selected category', categoryId);
    this.categoriesService.setSelectedCategoryById(categoryId);
}

get selectedCategory(): number | null {
    return this.categoriesService.selectedCategory()?.CategoryID || null;
}

  toggleAssemblies(value: string) {
    console.log('toggling assemblies', value);
    this.assemblyFilterService.selectTypes(value);
  }

  selectCategory(id: number) {
    this.assemblyFilterService.selectCategory(id);
  }


addAssembly() {
  const assembly: Assembly = new Assembly({
    CategoryID: this.selectedCategory || 321,
    FID: this.officesService.selectedOffice()?.FID || 0,
    Type: this.selectedType==='' ? 'O' : this.selectedType
  });

  this.selectedAssemblyService.setSelectedAssembly(assembly);
}

  onSelectOffice(value: any) {
    console.log('selecting office', value);
    const fid = value.FID;
    const office = this.officesService.getFilteredOffices('Assemblies', 'edit').find(o => o.FID === fid);
    if((office && office.Options_FID !== null && office.Options_FID !== office.FID) || (office && office.Standards_FID !== null && office.Standards_FID !== office?.FID)) {
      console.log('office has inherited assemblies');
      this.bannerMessagesService.replaceMessageType([{severity:'warn', type:'assemblyInherited', summary: 'Some Assemblies Inherited', detail: 'Some or all assemblies are inherited from another office. Editing those assemblies will affect both offices'}], 'assemblyInherited');
    }
    if(fid) {
      this.officesService.setSelectedOfficeById(fid);
    }
  }

}
